import React from "react"
import { Form } from "react-bootstrap"
import { useSelector } from "react-redux"

import { getCostAnalysis, getSeason } from "@/onboarding/features/cost_analysis/selectors"
import routes from "@/routes"

const ProductDropdown = (): JSX.Element => {
  const { selectedProductId } = useSelector(getCostAnalysis)
  const { selectableProducts } = useSelector(getSeason)

  return (
    <Form.Group>
      <Form.Label>Tour</Form.Label>
      <Form.Control
        as="select"
        value={selectedProductId || ""}
        onChange={(e) =>
          (window.location = routes.onboarding_product_cost_analysis_path({ id: e.target.value }))
        }
      >
        <option value="">Select a tour</option>
        {selectableProducts.map(({ value, label }) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}

export default ProductDropdown
